import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

/**
 * v1.2 — Build/version chip for the header.
 * Shows `Build: <short_sha>` in muted monospace; click-to-copy writes the full
 * `/api/__version` JSON (git_sha + build_timestamp + per-file fingerprint) to
 * clipboard for support attach-ups.
 *
 * Mounted in the header for super_admin only (per the IA).
 */
export default function BuildChip() {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    let alive = true;
    api.get("/__version")
      .then(({ data }) => { if (alive) setInfo(data); })
      .catch(() => { /* silent — non-critical */ });
    return () => { alive = false; };
  }, []);

  if (!info) return null;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(JSON.stringify(info, null, 2));
      toast.success("Build fingerprint copied");
    } catch {
      toast.error("Copy failed");
    }
  };

  return (
    <button
      type="button"
      onClick={copy}
      title={JSON.stringify(info, null, 2)}
      className="hidden md:inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-navy-50 dark:bg-navy-700 text-[11px] font-mono text-navy-500 dark:text-navy-200 hover:text-navy-900 dark:hover:text-white hover:bg-navy-100 dark:hover:bg-navy-600 transition-colors"
      data-testid="header-build-chip"
    >
      <span className="w-1.5 h-1.5 rounded-full bg-success" />
      Build: {info.git_sha}
    </button>
  );
}
